/**
 * Zentrale HTML-Sanitisierung für ALLE Stellen, die generiertes Kapitel-HTML per
 * innerHTML / dangerouslySetInnerHTML injizieren (LessonStream, Modul-Intro).
 *
 * Das HTML stammt aus dem eigenen Generator über eine authentifizierte API —
 * trotzdem filtern wir defensiv (Schichtenverteidigung, Review-Finding A4): kein
 * <script>, keine on*-Handler, keine javascript:-URLs. Die im Kurs genutzten
 * data-Attribute (Klick-Delegation) und <details>/<iframe> (Video) bleiben erhalten.
 */
import DOMPurify, { type Config } from "dompurify";

// Vimeo-/Video-Embeds im Lesetext brauchen iframe; data-* (Delegation) bleibt
// per Default erhalten (ALLOW_DATA_ATTR=true).
const CONFIG: Config = {
  ADD_TAGS: ["iframe"],
  ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling", "target"],
};

export function sanitizeHtml(html: string): string {
  if (!html) return "";
  // Ohne RETURN_TRUSTED_TYPE liefert sanitize() einen String.
  return DOMPurify.sanitize(html, CONFIG) as unknown as string;
}
